/**
 * Where a visit came from: the `?src=` value our own email links carry
 * (`school_watch_alert`, `school_watch_digest`, `email`, ...). Kept out of
 * analytics.ts so tests that mock analytics still get the real parser.
 *
 * Only short slug-like values are kept, so a hand-edited or foreign URL can't
 * put arbitrary text into an analytics property.
 */
const SOURCE_PATTERN = /^[a-z0-9][a-z0-9_-]{0,63}$/i;

export function sourceFromSearch(search: string | URLSearchParams): string | undefined {
  const params = typeof search === "string" ? new URLSearchParams(search) : search;
  const raw = params.get("src")?.trim();
  if (!raw || !SOURCE_PATTERN.test(raw)) return undefined;
  return raw.toLowerCase();
}

/** `{ source }` when there is one, `{}` otherwise, for spreading into event props. */
export function sourceProps(search: string | URLSearchParams): { source?: string } {
  const source = sourceFromSearch(search);
  return source ? { source } : {};
}
